// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2ABi_","tab":"Tabs_tab__1Hmta","tabActive":"Tabs_tabActive__1SiU1"};